import * as React from 'react';

const CollaspeButton = (props) => {
    return (
        <div
            className={`collaspe-box ${props.isOptionExpand ? '' : 'collaspe'}`}
            onClick={() => props.toggleOptionExpand()}
        >
            <i className="nx nx-arrow-d" />
        </div>
    );
};

export default CollaspeButton;
